export const payRangeLocales = {
  add: "Add",
  edit: "Edit",
  delete: "Delete",
  actions: "Action",
  addNew: "Add New",
  cancel: "Cancel",
  buttonSave: "SAVE",
  dollarSymbol: "$",
  emptyString: "",
  error: {
    payScaleEmpty: "The pay scale values cannot be empty.",
    payScaleLess: "The Starting pay rate should be lower than Ending pay rate.",
  },
  selectPayScale: "Select Pay Scale",
  sureToDelete: "Are you sure you want to delete this level?",
  payScales: "Pay Scales",
  addPayAndBill: "Add Pay Ranges and Bill Rates",
  payScaleNameRequired: "Pay scale name is required",
  failedToSave: "Failed to save pay scales. Please try again.",
  billRateLessThanNextLevelBillRate:
    "Bill rate must be less than next level's bill rate",
  allCatMustHave:
    "All categories must have at least one pay scale level before submitting",
  startingRateLessThanNextLevelStartRate:
    "Starting rate must be less than the next level's starting rate",
  endRateLessThanNextLevelStartRate:
    "Ending rate must be less than the next level's starting rate",
  billRateGreaterThanPrevious:
    "Bill rate must be greater than previous level's bill rate",
  billGThanEnd: "Billing rate must be greater than ending rate",
  billGThanStart: "Billing rate must be greater than starting rate",
  endGThanStart: "Ending rate must be greater than starting rate",
  endRateRequired: "Ending rate is required",
  billRateRequired: "Billing rate is required",
  rateGTZero: "Rate must be greater than zero",

  headBillHourly: "Bill Rate(Hourly)",
  headBillDaily: "Bill Rate(Daily)",
  headLevel: "Job Category",
  headMaxPayRateDaily: "Ending Pay Rate",
  headMaxPayRateHourly: "Ending Pay Rate",
  headMinPayRateHour: "Starting Pay Rate",
  headMinPayRateDaily: "Starting Pay Rate",
  level: "Level",
  message: {
    dueDate: "Due date must be on or before last date of job",
    errorMessage: "The Starting pay rate should be lower than Ending pay rate",
    savePayValue: "Your changes are updated successfully!",
    noMessage: "",
  },
  title: {
    payScale: "PayScale (Rate/hr)",
    payScaleDay: "PayScale (Rate/Day)",
    From: "From",
    to: "To",
  },
  payScaleName: "Pay Scale Name",
  enterPayScaleName: "Enter pay scale name",
  startingRateRequired: "Starting rate is required",
  invalidRateFormat:
    "Invalid rate format (use numbers with up to 2 decimal places)",
  startingRateGreaterThanPrevious:
    "Starting rate must be greater than the previous level's ending rate",
  endingRateRequired: "Ending rate is required",
  billingRateRequired: "Billing rate is required",
  endingRateGreaterThanStart: "Ending rate must be greater than starting rate",
  savePayValue: "Pay scale saved successfully.",
  confirmSubmission: "Confirm Submission",
  areYouSureToSubmit: "Are you sure you want to submit the pay scale?",
  confirm: "Confirm",
  addNewLevel: "Add New Level",
  editLevel: "Edit Level",
  updateLevel: "Update Level",
  addLevel: "Add Level",
  startingRate: "Starting Rate",
  endingRate: "Ending Rate",
  billingRate: "Bill Rate",
  billRatePercentage: "Payroll Burden Percentage",
  billRatePercentageRequired: "Payroll burden percentage is required",
  enterBillRatePercentage: "Enter payroll burden percentage",
  editPayrollBurdenPercentage: "Edit Payroll Burden Percentage",
  payrollBurdenUpdatePreview:
    "The following bill rates will be updated based on the new payroll burden percentage. Please confirm to continue.",
  currentBillRate: "Current Bill Rate",
  newBillRate: "New Bill Rate",
  reviewChanges: "Review Changes",
  noLevelsForBurdenPreview:
    "No pay scale levels available to preview bill rate changes.",
  addLevelBurdenRequiredMessage:
    "Please enter the Payroll Burden Percentage before adding a new level.",
  billRateCalculatedFromStartingRate:
    "Bill rate is calculated as starting rate plus payroll burden percentage of starting rate",
  transparencyBillRateInfo:
    "You can enter a maximum rate up to the bill rate corresponding to the ending pay rate.",
  transparencyBillRateRangeAlert:
    "You can enter a value between {minBillRate} and {maxBillRate}. This range is from starting rate plus payroll burden percentage of starting rate to ending rate plus payroll burden percentage of ending rate.",
  transparencyAssignBillRateRangeBanner:
    "You can enter a bill rate between {minBillRate} and {maxBillRate}.",
  transparencyAssignBillRateOutOfRange:
    "Bill rate must be between {minBillRate} and {maxBillRate}.",
  transparencyAssignPayRateRange:
    "You can enter a pay rate between {minPayRate} and {maxPayRate}.",
  transparencyAssignPayRateRangeBanner:
    "You can enter a pay rate between {minPayRate} and {maxPayRate}.",
  transparencyAssignPayRateOutOfRange:
    "Pay rate must be between {minPayRate} and {maxPayRate}.",
  deleteConfirmation: "Are you sure you want to delete this level?",
  noLevelsAdded: "(Requires at least one level)",
  noLevelsMessage: "*",
  submitPayScale: "Submit Pay Scale",
  successMessage: "Pay scale submitted successfully.",
  errorMessage: "Failed to save pay scales. Please try again.",
  noLevelsError:
    "All categories must have at least one pay scale level before submitting",
  update: "Update",
  payRangeNoteMsg:
    " The pay rate and bill rate is calculated in hourly rate. This is applicable only for",
  transparencyPayRangeNoteMsg:
    "Pay rate and bill rate are calculated as hourly rates and apply only to contract-to-hire jobs in the respective categories. Bill rate is calculated based on the starting pay rate and payroll burden percentage, and can be changed to a higher value during job assignment.",
  auxiliary: "Auxiliary",
  directHire: "Direct hire",
  directHireNote:
    "The Direct Hire Fee configured here applies to Exhibit A1, Exhibit A2, and Exhibit B. Any changes made will be reflected across all corresponding agreements.",
  directHireFee: "Bill Rate",
  directHireFeeRequired: "Direct hire fee is required",
  allCatMustHaveDirectHireFee:
    "All categories must have a direct hire fee before submitting",
  noDirectHireFeeAdded: "(Requires direct hire fee)",
  noSupportFeeAdded: "(Requires support fee)",
  noFullServiceFeeAdded: "(Requires full service fee)",
  noEscalationChargeAdded: "(Requires hourly escalation charge)",
  dentistFieldsIncomplete:
    "When dentist levels are added, direct hire fee, support fee, full service fee, and hourly escalation must all be configured with values greater than zero",
  addPay: "Add Pay",
  editPay: "Edit Pay",
  addDirectHireFee: "Add Pay",
  editDirectHireFee: "Edit Pay",
  payScalesAuxiliary: "Pay Scales (Auxiliary)",
  standardPricing: "Standard Pricing",
  transparencyModel: "Transparency model",
  referralJob: "Referral Job",
  placementSupportFee: "Placement Support Fee",
  supportFee: "Support Fee",
  ddsFullServiceFee: "DDS Full Service Fee (Daily Base Rate up to 8 Hours)",
  dailyFullServiceFee: "Daily Full Service Fee",
  hourlyEscalation: "Hourly Escalation (Over 8 Hours)",
  hoursWorked: "Hours Worked",
  additionalCharge: "Additional Charge",
  upTo8Hours: "Upto 8 hrs",
  hours8To9: "8:01 - 8:59 hrs",
  hours9To10: "9:00 - 9:59 hrs",
  hours10OrMore: "10 hrs or more",
  editSupportFee: "Edit Support Fee",
  editFullServiceFee: "Edit Full Service Fee",
  editHourlyEscalation: "Edit Hourly Escalation",
  supportFeeRequired: "Support fee is required",
  fullServiceFeeRequired: "Full service fee is required",
  additionalChargeRequired: "Additional charge is required",
  referralJobSection: "Referral job",
  referralJobBillRate: "Bill Rate",
  editReferralFee: "Edit Pay",
  addReferralFee: "Add Pay",
  referralFeeRequired: "Referral job bill rate is required",
};
